import { DAU_DELTA, MAU_DELTA, type HuongChiSo } from '../../../ui/index.js';
import { gonSo, huongDelta, phanTram } from './dinhDang.js';

/**
 * Chỉ số **Lượt xem** của trang Tổng quan — một nguồn cho **cả hai** chỗ in nó.
 *
 * ## Lỗi: hai chỗ, hai con số, cùng một kỳ
 *
 * Trước 26/10/2026 ô "Lượt xem" trong dải chỉ số ghi `9,05M ▲ 2,1%`, còn tiêu
 * đề biểu đồ "Lượt xem toàn hệ thống" ngay dưới nó ghi `9,0M ↑ 5,0%`. Ba thứ
 * lệch cùng lúc, và không chỗ nào nói ra:
 *
 * | | ô chỉ số | tiêu đề biểu đồ (cũ) |
 * |---|---|---|
 * | số | `gonSo(views)` → `9,05M` | `gonSo(views, 1)` → `9,0M` |
 * | phần trăm | so **kỳ trước** (`viewsDeltaPercent`) | mốc cuối so mốc **đầu** của chính biểu đồ |
 * | ký hiệu | `▲` / `▼` | `↑` / `↓` |
 *
 * Phép so "mốc cuối với mốc đầu" trả lời một câu khác hẳn ("tuần này so tuần
 * đầu kỳ") mà lại đứng cạnh một con số của cả kỳ, nên nó chỉ gây hiểu nhầm —
 * bỏ hẳn, không đổi tên.
 *
 * Nay cả hai chỗ gọi hàm này. Hai chỗ lệch nhau nghĩa là một chỗ không gọi nó,
 * và bài `__tests__/luotXem.test.tsx` chặn đúng việc đó.
 */
export interface ChiSoLuotXem {
  /** `9,05M`, hoặc `—` khi kỳ chưa có ngày nào có số liệu. */
  so: string;
  /** `null` khi không có kỳ trước để so ("Toàn thời gian", hoặc kỳ trước thiếu ngày). */
  delta: {
    huong: HuongChiSo;
    /** `▲` / `▼` / `—`, lấy từ chính bảng mà `StatStrip` dùng. */
    dau: string;
    /** Lớp màu Tailwind, cũng từ bảng của `StatStrip`. */
    mau: string;
    /** `2,1%` — **không dấu**, vì mũi tên đã nói chiều. */
    pct: string;
  } | null;
}

export function chiSoLuotXem(
  views: number | null | undefined,
  deltaPhanTram: number | null | undefined,
): ChiSoLuotXem {
  const so = gonSo(views);

  if (deltaPhanTram === null || deltaPhanTram === undefined) return { so, delta: null };

  const huong = huongDelta(deltaPhanTram);
  return {
    so,
    delta: { huong, dau: DAU_DELTA[huong], mau: MAU_DELTA[huong], pct: phanTram(deltaPhanTram) },
  };
}
